import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2k42t3uyu: FaireProductEntity = {
  token: "p_z2k42t3uyu",
  type: "product",
  name: "Acrylic Notes Bloc",
  brandName: "russell+hazel",
  imageUrl:
    "https://cdn.faire.com/fastly/afe01d86eab82e9e1a738a6c37801397f33409fa6091b32263914e3782c76b08.jpeg",
  priceDollars: 7.2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a10ef67bb7921942340ee87220a5aa6289e35ce4b4988e65fb2c53a395558d9c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
